export default __webpack_public_path__ + "static/media/grass.1582fee8.png";